import React from 'react';
import RenderHTML from 'automaailm-ui/lib/Components/RenderHTML';
import Tabs from 'automaailm-ui/lib/Components/Tabs';

interface ITab {
    label: string;
    content: string;
}

interface IProps {
    config: {
        tabs: ITab[];
    };
}

export default function DescriptionTabs(props: IProps) {
    const { config } = props;
    const { tabs } = config;

    const tabData = {};
    tabs.forEach((tab) =>
        Object.assign(tabData, { [tab.label]: { title: tab.label, content: <RenderHTML html={tab.content} /> } }),
    );

    return <React.Fragment>{tabs.length > 0 && <Tabs activeTab={tabs[0].label} tabs={tabData} />}</React.Fragment>;
}
